<template>
  <div>

    <v-row>
      <v-btn :text="view !== 0" @click="view = 0">
        Raw
      </v-btn>
      <v-btn :text="view !== 1" @click="view = 1">
        Visual
      </v-btn>
    </v-row>

    <div v-if="view === 0">
      <json-viewer :item="schema"></json-viewer>
    </div>

    <div v-else-if="view === 1">

      <list-row v-for="key of Object.keys(schema)" :key="key" :v_key="key" :v_value="schema[key]" @onDelete="deleteItem(key)">
      </list-row>

    </div>

    <v-row>
      <v-btn @click="addItem">
        Add
      </v-btn>
    </v-row>

    <v-row>
      <v-btn @click="save">
        Save
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import ListRow from './row'
import JsonViewer from '@/components/toolbox/json-viewer/Main'
import { SETTINGS as STATIC_SETTINGS } from '@/js/shared/static-strings.js'

export default {
  components: {
    ListRow,
    JsonViewer
  },
  data () {
    return {
      view: 0,
      schema: {},
      saving: false
    }
  },
  methods: {
    addItem () {
      var i = 1
      while (true) {
        if (!this.schema.hasOwnProperty(`key_${i}`)){
          console.log('breaking')
          break
        }
        i++
      }
      Vue.set(this.schema, `key_${i}`, {
        type: 'boolean',
        _default: false,
        name: 'Cosmos Organic'
      })
    },
    deleteItem (key) {
      Vue.delete(this.schema, key)
    },
    save () {
      return new Promise((resolve, reject) => {
        let data = {
          key: STATIC_SETTINGS.INVENTORY_DEFINITION_SCHEMA,
          value: this.schema
        }
        this.saving = true
        this.$axios.patch(`settings/update`,
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            this.loadAPI()
            resolve()
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            setTimeout(() => {
            this.saving = false
            }, 200)
          })
      })
    },
    loadAPI () {
      this.schema = JSON.parse(this.$store.state.settings.dict[STATIC_SETTINGS.INVENTORY_DEFINITION_SCHEMA]) || {}
    }
  },
  created () {
    this.loadAPI()
  }
}
</script>